import React, { useEffect, useRef } from 'react';
import CheckboxOnly from './CheckboxOnly';
import { Typography } from '../../index';
import './checkbox.scss';


const CheckboxItem = React.forwardRef(({
    disabled = false,
    error = false,
    indeterminate = false,
    label,
    name,
    onChange,
    onClick,
    required = false,
    size = "sm",
    value,
}, inputRef) => {

    const checkboxItemClasses = [
        `bsw-checkbox__checkbox-item`,
        `bsw-checkbox__checkbox-item--size-${size}`,
        `${disabled ? 'bsw-checkbox__checkbox-item--disabled' : ''}`
    ].join(' ');

    return (<label className={checkboxItemClasses}>
        <CheckboxOnly
            disabled={disabled}
            error={error}
            indeterminate={indeterminate}
            //label={label}
            name={name}
            onClick={onClick}
            onChange={onChange}
            inputRef={inputRef}
            required={required}
            size={size}
            value={value}
        />
        {label && 
            <div className="bsw-checkbox__checkbox-item-label">
                <Typography
                    color={disabled ? "$color-secondary-a3" : "" }
                    type="body-02"
                >
                    {label}
                </Typography>
            </div>
        }
    </label>)
})

export default CheckboxItem;